var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { QboFormElement } from '@quandis/qbo4.ui';
const contactNameMap = new Map();
contactNameMap.set('defaultLayout', (component) => {
    return html `<div slot="content" class="${component.slotClass}">
            <input type="text" ?disabled=${component.disabled} class="${component.getAttribute("class")}" name="${component.getAttribute("name")}" value="${component.data?.['Contact']}"/>
            <qbo-popup>
                <div slot="button">
                    <span class="${component.spanClass}">
                        <i class="${component.icon}"></i>
                    </span>
                </div>
                <div slot="content">
                    <div class="${component.modalDivClass}">
                        <div class="${component.modalDialogDivClass}">
                            <div class="${component.modalContentDivClass}">
                                <div class="${component.modalHeaderDivClass}">${component.modalHeaderText}</div>
                                <div class="${component.modalBodyDivClass}">
                                    <qbo-select ?disabled=${component.disabled} class="${component.elementClass}" name="Prefix" apiEndpoint="api://qbo/objecttype/list?object=Contact.Prefix" optionValue="ObjectType" defaultValue="${component.data?.['Prefix']}" emptyOptionText="-- Prefix --"></qbo-select>
                                    <input type="text" ?disabled=${component.disabled} class="${component.elementClass} ${component.elementStackedTopClass}" name="FirstName" placeholder="First Name" value="${component.data?.['FirstName']}"/>
                                    <input type="text" ?disabled=${component.disabled} class="${component.elementClass} ${component.elementStackedTopClass}" name="MiddleName" placeholder="Middle Name" value="${component.data?.['MiddleName']}"/>
                                    <input type="text" ?disabled=${component.disabled} class="${component.elementClass} ${component.elementStackedTopClass}" name="LastName" placeholder="Last Name" value="${component.data?.['LastName']}"/>
                                    <qbo-select ?disabled=${component.disabled} class="${component.elementClass} ${component.elementStackedTopClass}" name="Suffix" apiEndpoint="api://qbo/objecttype/list?object=Contact.Suffix" optionValue="ObjectType" defaultValue="${component.data?.['Suffix']}" emptyOptionText="-- Suffix --"></qbo-select>
                                </div>
                                <div class="${component.modalFooterDivClass}">
                                    <button type="button" class="${component.buttonClass}" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </qbo-popup>
        </div>`;
});
let QboContactName = class QboContactName extends QboFormElement {
    constructor() {
        super(...arguments);
        this.buttonClass = 'qbo-secondary';
        this.disabled = true;
        this.elementClass = 'qbo-sm';
        this.elementStackedTopClass = 'qbo-sm-top';
        this.icon = 'qbo-icon-person-lines-fill';
        this.modalBodyDivClass = 'qbo-modal-body';
        this.modalContentDivClass = 'qbo-modal-content';
        this.modalDivClass = 'qbo-modal';
        this.modalDialogDivClass = 'qbo-modal-dialog';
        this.modalFooterDivClass = 'qbo-modal-footer';
        this.modalHeaderDivClass = 'qbo-modal-header';
        this.modalHeaderText = 'Contact Name';
        this.slotClass = 'qbo-input-group';
        this.spanClass = 'qbo-input-group-text qbo-pointer';
        this.type = 'defaultLayout';
        this.renderInHost = true;
    }
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    render() {
        return html `<slot>${contactNameMap.has(this.type) ? contactNameMap.get(this.type)(this) : null}</slot>`;
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "buttonClass", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboContactName.prototype, "disabled", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "elementClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "elementStackedTopClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "icon", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "modalBodyDivClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "modalContentDivClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "modalDivClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "modalDialogDivClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "modalFooterDivClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "modalHeaderDivClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "modalHeaderText", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "slotClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContactName.prototype, "spanClass", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboContactName.prototype, "type", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboContactName.prototype, "renderInHost", void 0);
QboContactName = __decorate([
    customElement('qbo-contact-name')
], QboContactName);
export { QboContactName };
